module.exports = __webpack_public_path__ + "img/firstPage.8ec821f6.png";